import { render, staticRenderFns } from "./TgWishcard.vue?vue&type=template&id=ef75284c&scoped=true&"
import script from "./TgWishcard.vue?vue&type=script&lang=js&"
export * from "./TgWishcard.vue?vue&type=script&lang=js&"
import style0 from "./TgWishcard.vue?vue&type=style&index=0&id=ef75284c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef75284c",
  null
  
)

export default component.exports